import request from '@/utils/request'
const apiPath = '/sys/sysDepartment'
const sysDepartmentApi = {
  /**
   * 新增【系统部门】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【系统部门】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【系统部门】
   */
  fetchList(query) {
    return request.get(apiPath+'/tee', { params: query })
  },
  /**
   * 查询【系统部门】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【系统部门】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【系统部门】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【系统部门】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  // 获取下拉数据
  getMiniList(query){
    return request.get(`${apiPath}/tee/miniList`, { params: query })
  }
}
export default sysDepartmentApi
